// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__XGKBj","form":"styles_form__2yEfn"};